export class AccountFilter {
  groupId: string;
  firstName: string;
  lastName: string;
  email: string;
  lastConnectionDate: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/filters/account-filter.ts